import { TimezoneWrapper } from '@core/models/timezone-wrapper';
import { createReducer, on } from '@ngrx/store';
import {
  LoadTimezonesProperties,
  LoadTimezonesProps,
  SetRecipientTimezone,
  SetSenderTimezone,
} from './timezones.actions';

export interface TimezonesState {
  timezonesProperties: TimezoneWrapper[];
  senderTimezone: any;
  recipientTimezone: any;
}

export const initialTimezonesState: TimezonesState = {
  timezonesProperties: [],
  senderTimezone: {},
  recipientTimezone: {},
};

export const timezonesReducer = createReducer(
  initialTimezonesState,

  on(LoadTimezonesProps, (state) => {
    return {
      ...state,
    };
  }),

  on(LoadTimezonesProperties, (state, { timezonesProperties }) => {
    return {
      ...state,
      timezonesProperties,
    };
  }),
  on(SetSenderTimezone, (state, { senderTimezone }) => {
    return {
      ...state,
      senderTimezone,
    };
  }),

  on(SetRecipientTimezone, (state, { recipientTimezone }) => {
    return {
      ...state,
      recipientTimezone,
    };
  })
);
